import React from 'react';
import './RefundDetailsSkeleton.css';

const RefundDetailsSkeleton = () => {
  return (
    <div className="refund-details-skeleton-container">
      <div className="refund-details-skeleton-breadcrumb" />

      <div className="refund-details-skeleton-header">
        <div className="refund-details-skeleton-title" />
        <div className="refund-details-skeleton-badge" />
      </div>

      <div className="refund-details-skeleton-date" />

      <div className="refund-details-skeleton-section">
        <div className="refund-details-skeleton-section-title" />
        <div className="refund-details-skeleton-grid">
          <div className="refund-details-skeleton-field">
            <div className="refund-details-skeleton-label" />
            <div className="refund-details-skeleton-value" />
          </div>
          <div className="refund-details-skeleton-field">
            <div className="refund-details-skeleton-label" />
            <div className="refund-details-skeleton-value-badge" />
          </div>
          <div className="refund-details-skeleton-field">
            <div className="refund-details-skeleton-label" />
            <div className="refund-details-skeleton-value" />
          </div>
          <div className="refund-details-skeleton-field">
            <div className="refund-details-skeleton-label" />
            <div className="refund-details-skeleton-value" />
          </div>
          <div className="refund-details-skeleton-field">
            <div className="refund-details-skeleton-label" />
            <div className="refund-details-skeleton-value" />
          </div>
          <div className="refund-details-skeleton-field refund-details-skeleton-field-full">
            <div className="refund-details-skeleton-label" />
            <div className="refund-details-skeleton-value-long" />
          </div>
        </div>
      </div>

      <div className="refund-details-skeleton-section">
        <div className="refund-details-skeleton-section-title" />
        <div className="refund-details-skeleton-grid">
          <div className="refund-details-skeleton-field">
            <div className="refund-details-skeleton-label" />
            <div className="refund-details-skeleton-value" />
          </div>
          <div className="refund-details-skeleton-field">
            <div className="refund-details-skeleton-label" />
            <div className="refund-details-skeleton-value" />
          </div>
          <div className="refund-details-skeleton-field">
            <div className="refund-details-skeleton-label" />
            <div className="refund-details-skeleton-value" />
          </div>
          <div className="refund-details-skeleton-field">
            <div className="refund-details-skeleton-label" />
            <div className="refund-details-skeleton-value" />
          </div>
          <div className="refund-details-skeleton-field">
            <div className="refund-details-skeleton-label" />
            <div className="refund-details-skeleton-value" />
          </div>
          <div className="refund-details-skeleton-field">
            <div className="refund-details-skeleton-label" />
            <div className="refund-details-skeleton-value" />
          </div>
        </div>
      </div>

      <div className="refund-details-skeleton-section">
        <div className="refund-details-skeleton-section-title" />
        <div className="refund-details-skeleton-payment">
          <div className="refund-details-skeleton-payment-row">
            <div className="refund-details-skeleton-label" />
            <div className="refund-details-skeleton-value" />
          </div>
          <div className="refund-details-skeleton-payment-row">
            <div className="refund-details-skeleton-label" />
            <div className="refund-details-skeleton-value" />
          </div>
        </div>
      </div>

      <div className="refund-details-skeleton-actions">
        <div className="refund-details-skeleton-button" />
        <div className="refund-details-skeleton-button" />
      </div>
    </div>
  );
};

export default RefundDetailsSkeleton;
